import React from 'react';

import SiteNav from './SiteNav';
import usePageMeta from 'seo/usePageMeta';
import SiteFooter from './SiteFooter';

// Layout for the public sub-pages (contact, buy-now) in the landing design.
const PageShell = ({ path, kicker, title, text, children }) => {
  usePageMeta(path);
  return (
    <div className="op-home op-page">
      <a className="op-skip" href="#icerik">
        İçeriğe geç
      </a>
      <SiteNav />
      <main id="icerik">
        <header className="op-wrap op-page__head">
          <span className="op-kicker">{kicker}</span>
          <h1>{title}</h1>
          <p>{text}</p>
        </header>
        <div className="op-wrap op-page__body">{children}</div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default PageShell;
